import React from "react";
import { Pagination } from "antd";
import { SIZE_SMALL } from "constants/ui.constants";
import { PAGE_SIZE_OPTIONS, TEXT } from "../../GroupSkillsProficiencyV2.constants";
import {
  PaginationFooterContainerStyled,
  PaginationTotalTextStyled,
} from "./SkillsPaginationFooter.styles";

const SkillsPaginationFooter = ({ currentPage, pageSize, total, onChange }) => {
  const rangeStart = (currentPage - 1) * pageSize + 1;
  const rangeEnd = Math.min(currentPage * pageSize, total);
  const countOnPage = rangeEnd - rangeStart + 1;

  return (
    // Flex props: align + justify. styled adds border, padding, background.
    <PaginationFooterContainerStyled align="center" justify="space-between">

      {/* Flex props: align + gap. styled adds font-size, color. */}
      <PaginationTotalTextStyled align="center" gap={6}>
        {TEXT.PAGINATION_SHOWING} <strong>{pageSize}</strong> {TEXT.PAGINATION_ITEMS_PER_PAGE}&nbsp;
        ({countOnPage} of {total} skills)
      </PaginationTotalTextStyled>

      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={total}
        onChange={onChange}
        showSizeChanger
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        size={SIZE_SMALL}
      />

    </PaginationFooterContainerStyled>
  );
};

export default SkillsPaginationFooter;
